import { render, staticRenderFns } from "./DashDemandReview.vue?vue&type=template&id=8317878c&scoped=true&"
import script from "./DashDemandReview.vue?vue&type=script&lang=js&"
export * from "./DashDemandReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8317878c",
  null
  
)

export default component.exports